import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { AccountType } from 'eve-account-client';
import { useEnrollment } from '../../../context/Enrollment/EnrollmentContext';
import { EnrollmentData } from '../EnrollmentData';
import CompanyInformationForm, {
  CompanyInformationSubmitData,
} from '../../../components/Enrollment/CompanyInformation/CompanyInformationForm';
import FormVariant from '../../../components/Enrollment/FormVariant';
import { removeEmptyStrings } from '../../../utils/util';

const CompanyInformation = (): JSX.Element => {
  const { enrollmentData, setEnrollmentData, nextPage } = useEnrollment();
  const pageTitle = 'Company Information';

  const handleSubmit = (data: CompanyInformationSubmitData) => {
    removeEmptyStrings(data);
    setEnrollmentData((prevState: EnrollmentData) => {
      return {
        ...prevState,
        companyInformationFormData: data.companyInfoData,
        marketingChannel: data.marketingChannelData,
      };
    });
    nextPage();
  };
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      pageTitle: 'E-Verify - Company Information',
    });
  }, []);
  return (
    <section className="padding-top-4">
      <h1 className="margin-bottom-4">{pageTitle}</h1>
      <CompanyInformationForm
        isEmployer={enrollmentData.accessMethodFormData?.type === AccountType.EMPLOYER}
        isCorporateAdmin={enrollmentData.accessMethodFormData?.type === AccountType.CORPORATE}
        isAgent={enrollmentData.accessMethodFormData?.type === AccountType.AGENCY}
        isChild={enrollmentData.accessMethodFormData?.type === AccountType.CHILD}
        variantType={FormVariant.ENROLLMENT}
        companyInfoData={enrollmentData.companyInformationFormData}
        marketingChannelData={enrollmentData.marketingChannel}
        categoryType={enrollmentData.employerCategoryFormData?.category}
        onSubmitForm={handleSubmit}
      />
    </section>
  );
};

export default CompanyInformation;
